import https from "../../configs/axios.config";
import { API_ROUTES } from "../../constants/API_ROUTES";

export const notiService = {
  get_all: async (token, page) => {
    const response = await https.get(
      `${API_ROUTES.NOTI.GET_ALL}?page=${page}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return response;
  },
  delete: async (token) => {
    const response = await https.delete(`${API_ROUTES.NOTI.DELETE_ALL}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response;
  },
  mark_as_read: async (id, token) => {
    const response = await https.get(`${API_ROUTES.NOTI.MARK_AS_READ}/${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response;
  },
  get_count: async (token) => {
    const response = await https.get(`${API_ROUTES.NOTI.GET_COUNT}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response;
  },
};
